<button class="reset-btn" [ngClass]="className" type="button">
  <svg class="reset-btn__icon">
    <use xlink:href="#icon-circled-x" />
  </svg>
</button>
